import { Moon, Sun, ScanEye, ShieldCheck, Server, Save } from 'lucide-react';
import SeriesTemplate from '../components/SeriesTemplate';

const IrNightVision = () => {
  const features = [
    {
      Icon: Moon,
      title: '赤外線による夜間撮影',
      desc: '明かりの少ない環境でも赤外線照射により対象を確認できます。',
    },
    {
      Icon: Sun,
      title: '昼夜自動切り替え',
      desc: '周囲の明るさに応じてカラー/赤外線モードを自動で切り替えます。',
    },
    {
      Icon: ScanEye,
      title: '人・車両検知',
      desc: '人や車両の検知に対応し、夜間の入退確認にも活用できます。',
    },
    {
      Icon: ShieldCheck,
      title: '屋外設置に対応',
      desc: 'IP66対応モデルがあり、屋外の外周や倉庫まわりに設置できます。',
    },
    {
      Icon: Server,
      title: 'NVR・録画機器と連携',
      desc: 'カメラ台数、録画日数に合わせた録画構成に対応します。',
    },
    {
      Icon: Save,
      title: 'microSD対応モデル',
      desc: '本体側のバックアップ録画にも対応するモデルがあります。',
    },
  ];

  const notes = [
    '赤外線映像はモノクロで記録されます。色情報が必要な場合はSuper ColorVuシリーズをご検討ください。',
    '照射距離は設置位置・対象物の反射率・周囲環境により異なります。',
    '屋外設置の場合は、配線経路・取付位置・防水処理の確認が必要です。',
    '機種や設定内容により、使用できる機能が異なる場合があります。',
  ];

  return (
    <SeriesTemplate
      id="ir"
      eyebrow="IR NIGHT VISION"
      name="IRナイトビジョンカメラシリーズ"
      description="赤外線による夜間・暗所の撮影に対応した防犯カメラシリーズです。夜間の外周、屋外、倉庫、駐車場など、明かりの少ない現場に向いています。"
      tags={['赤外線', '4MP / 8MP', 'PoE対応', 'IP66', '顔認識対応', '遠隔確認']}
      heroImage="/images/ir-night-vision.png"
      features={features}
      locations={['夜間外周', '倉庫', '屋外設備', '駐車場', '資材置場', '工場まわり', '施設外周']}
      notes={notes}
    />
  );
};

export default IrNightVision;
